"use strict";

var _interopRequireDefault = require("/Volumes/Untitled/project/185/185admin/node_modules/@babel/runtime/helpers/interopRequireDefault.js").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
require("core-js/modules/es.array.concat.js");
require("core-js/modules/es.array.map.js");
require("core-js/modules/es.function.name.js");
require("core-js/modules/es.object.to-string.js");
var _objectSpread2 = _interopRequireDefault(require("/Volumes/Untitled/project/185/185admin/node_modules/@babel/runtime/helpers/objectSpread2.js"));
var _regeneratorRuntime2 = _interopRequireDefault(require("/Volumes/Untitled/project/185/185admin/node_modules/@babel/runtime/helpers/regeneratorRuntime.js"));
var _asyncToGenerator2 = _interopRequireDefault(require("/Volumes/Untitled/project/185/185admin/node_modules/@babel/runtime/helpers/asyncToGenerator.js"));
var _classCallCheck2 = _interopRequireDefault(require("/Volumes/Untitled/project/185/185admin/node_modules/@babel/runtime/helpers/classCallCheck.js"));
var _createClass2 = _interopRequireDefault(require("/Volumes/Untitled/project/185/185admin/node_modules/@babel/runtime/helpers/createClass.js"));
var _callSuper2 = _interopRequireDefault(require("/Volumes/Untitled/project/185/185admin/node_modules/@babel/runtime/helpers/callSuper.js"));
var _inherits2 = _interopRequireDefault(require("/Volumes/Untitled/project/185/185admin/node_modules/@babel/runtime/helpers/inherits.js"));
var _defineProperty2 = _interopRequireDefault(require("/Volumes/Untitled/project/185/185admin/node_modules/@babel/runtime/helpers/defineProperty.js"));
var _tslib = require("tslib");
var _customer = require("@/api/customer");
var _moment = _interopRequireDefault(require("moment"));
var _vuePropertyDecorator = require("vue-property-decorator");
var _CustomerOrderForm = _interopRequireDefault(require("./CustomerOrderForm.vue"));
var _ProductOrderForm = _interopRequireDefault(require("./ProductOrderForm.vue"));
var _returnOrder = require("@/api/returnOrder.api");
var OrderModal = /*#__PURE__*/function (_Vue) {
  function OrderModal() {
    var _this;
    (0, _classCallCheck2.default)(this, OrderModal);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = (0, _callSuper2.default)(this, OrderModal, [].concat(args));
    (0, _defineProperty2.default)(_this, "disabled", void 0);
    (0, _defineProperty2.default)(_this, "$refs", void 0);
    (0, _defineProperty2.default)(_this, "visible", false);
    (0, _defineProperty2.default)(_this, "form", {
      details: []
    });
    (0, _defineProperty2.default)(_this, "status", "create");
    (0, _defineProperty2.default)(_this, "orderStatus", "");
    (0, _defineProperty2.default)(_this, "loading", false);
    (0, _defineProperty2.default)(_this, "createdAt", 0);
    (0, _defineProperty2.default)(_this, "compareOrder", {});
    return _this;
  }
  (0, _inherits2.default)(OrderModal, _Vue);
  return (0, _createClass2.default)(OrderModal, [{
    key: "disabledForm",
    get: function get() {
      return this.disabled;
    }
  }, {
    key: "checkCustomerMonthBirthday",
    get: function get() {
      if (!this.form.detailCustomer) {
        return false;
      }
      var birthdayMonth = (0, _moment.default)(this.form.detailCustomer.customer.birthday, "DD/MM/YYYY").format("MM");
      var currentMonth = (0, _moment.default)().format("MM");
      if (birthdayMonth == currentMonth) {
        return true;
      }
      return false;
    }
  }, {
    key: "dataSubmit",
    get: function get() {
      return {
        returnOrder: {
          type: this.form.type
        },
        details: this.form.details.map(function (e) {
          return {
            price: e.retailPrice,
            quantity: e.quantity,
            productId: e.id,
            lotNumber: e.lotNumber,
            dateOfManufacture: e.dateOfManufacture,
            expired: e.expired,
            id: e.detailId
          };
        }),
        customerId: this.form.customerId
      };
    }
  }, {
    key: "handleCheckRankCustomer",
    value: function () {
      var _handleCheckRankCustomer = (0, _asyncToGenerator2.default)( /*#__PURE__*/(0, _regeneratorRuntime2.default)().mark(function _callee() {
        return (0, _regeneratorRuntime2.default)().wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              return _context.abrupt("return");
            case 1:
            case "end":
              return _context.stop();
          }
        }, _callee);
      }));
      function handleCheckRankCustomer() {
        return _handleCheckRankCustomer.apply(this, arguments);
      }
      return handleCheckRankCustomer;
    }()
  }, {
    key: "handleDelete",
    value: function () {
      var _handleDelete = (0, _asyncToGenerator2.default)( /*#__PURE__*/(0, _regeneratorRuntime2.default)().mark(function _callee2() {
        return (0, _regeneratorRuntime2.default)().wrap(function _callee2$(_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              _context2.next = 2;
              return this.$confirm("Confirm delete return order", "Warning", {
                cancelButtonText: "No",
                confirmButtonText: "Delete",
                type: "warning"
              });
            case 2:
              _context2.prev = 2;
              this.loading = true;
              // const reason = res.value;
              _context2.next = 6;
              return _returnOrder.returnOrderApi.delete(this.form.id);
            case 6:
              this.$emit("submit:ok");
              this.visible = false;
              this.$notify.success({
                title: "Delete order",
                message: "Successfully"
              });
            case 9:
              _context2.prev = 9;
              this.loading = false;
              return _context2.finish(9);
            case 12:
            case "end":
              return _context2.stop();
          }
        }, _callee2, this, [[2,, 9, 12]]);
      }));
      function handleDelete() {
        return _handleDelete.apply(this, arguments);
      }
      return handleDelete;
    }()
  }, {
    key: "createData",
    value: function () {
      var _createData = (0, _asyncToGenerator2.default)( /*#__PURE__*/(0, _regeneratorRuntime2.default)().mark(function _callee3() {
        var res;
        return (0, _regeneratorRuntime2.default)().wrap(function _callee3$(_context3) {
          while (1) switch (_context3.prev = _context3.next) {
            case 0:
              _context3.prev = 0;
              _context3.next = 3;
              return this.$refs.customer.$refs.form.validate();
            case 3:
              _context3.next = 5;
              return this.$refs.product.$refs.form.validate();
            case 5:
              _context3.next = 10;
              break;
            case 7:
              _context3.prev = 7;
              _context3.t0 = _context3["catch"](0);
              return _context3.abrupt("return", this.$message.error("Fill correct all input"));
            case 10:
              if (!this.form.details.some(function (el) {
                return el.quantity > el.productQuantity;
              })) {
                _context3.next = 12;
                break;
              }
              return _context3.abrupt("return", this.$message.error("The quantity entered must be less than the quantity of lot number"));
            case 12:
              if (this.form.details.length) {
                _context3.next = 14;
                break;
              }
              return _context3.abrupt("return", this.$message.error("Products least 1 item!"));
            case 14:
              this.loading = true;
              _context3.prev = 15;
              _context3.next = 18;
              return _returnOrder.returnOrderApi.create(this.dataSubmit);
            case 18:
              res = _context3.sent;
              this.$notify.success({
                title: "New consignment",
                message: "Successfully"
              });
              this.$emit("submit:ok");
              this.visible = false;
            case 22:
              _context3.prev = 22;
              this.loading = false;
              return _context3.finish(22);
            case 25:
            case "end":
              return _context3.stop();
          }
        }, _callee3, this, [[0, 7], [15,, 22, 25]]);
      }));
      function createData() {
        return _createData.apply(this, arguments);
      }
      return createData;
    }()
  }, {
    key: "updateData",
    value: function () {
      var _updateData = (0, _asyncToGenerator2.default)( /*#__PURE__*/(0, _regeneratorRuntime2.default)().mark(function _callee4() {
        return (0, _regeneratorRuntime2.default)().wrap(function _callee4$(_context4) {
          while (1) switch (_context4.prev = _context4.next) {
            case 0:
            case "end":
              return _context4.stop();
          }
        }, _callee4);
      }));
      function updateData() {
        return _updateData.apply(this, arguments);
      }
      return updateData;
    }()
  }, {
    key: "handleCreate",
    value: function handleCreate(type) {
      this.visible = true;
      this.status = "create";
      this.form = {
        details: [],
        customerId: null,
        type: type
      };
      this.orderStatus = "";
    }
  }, {
    key: "fetchDetailCustomer",
    value: function () {
      var _fetchDetailCustomer = (0, _asyncToGenerator2.default)( /*#__PURE__*/(0, _regeneratorRuntime2.default)().mark(function _callee5() {
        var res;
        return (0, _regeneratorRuntime2.default)().wrap(function _callee5$(_context5) {
          while (1) switch (_context5.prev = _context5.next) {
            case 0:
              if (this.form.customerId) {
                _context5.next = 2;
                break;
              }
              return _context5.abrupt("return", false);
            case 2:
              console.log("this.form.customerId:", this.form.customerId);
              _context5.next = 5;
              return _customer.customerApi.findOne(this.form.customerId);
            case 5:
              res = _context5.sent;
              this.$set(this.form, "detailCustomer", res.data);
            case 7:
            case "end":
              return _context5.stop();
          }
        }, _callee5, this);
      }));
      function fetchDetailCustomer() {
        return _fetchDetailCustomer.apply(this, arguments);
      }
      return fetchDetailCustomer;
    }()
  }, {
    key: "handleUpdate",
    value: function () {
      var _handleUpdate = (0, _asyncToGenerator2.default)( /*#__PURE__*/(0, _regeneratorRuntime2.default)().mark(function _callee6(data) {
        return (0, _regeneratorRuntime2.default)().wrap(function _callee6$(_context6) {
          while (1) switch (_context6.prev = _context6.next) {
            case 0:
              this.form = (0, _objectSpread2.default)((0, _objectSpread2.default)({}, data), {}, {
                details: data.returnOrderDetails.map(function (e) {
                  return (0, _objectSpread2.default)((0, _objectSpread2.default)({}, e), {}, {
                    id: e.product.id,
                    name: e.product.name,
                    detailId: e.id,
                    retailPrice: e.price,
                    originPrice: e.product.originPrice,
                    productId: e.product.id,
                    isPublished: e.product.isPublished,
                    productGalleries: e.product.productGalleries
                  });
                }),
                customerId: data.customer ? data.customer.id : 0
              });
              this.fetchDetailCustomer();
              this.visible = true;
              this.status = "update";
              // this.orderStatus = data.status;
            case 4:
            case "end":
              return _context6.stop();
          }
        }, _callee6, this);
      }));
      function handleUpdate(_x) {
        return _handleUpdate.apply(this, arguments);
      }
      return handleUpdate;
    }()
  }]);
}(_vuePropertyDecorator.Vue);
(0, _tslib.__decorate)([(0, _vuePropertyDecorator.Prop)()], OrderModal.prototype, "disabled", void 0);
OrderModal = (0, _tslib.__decorate)([(0, _vuePropertyDecorator.Component)({
  components: {
    ProductOrderForm: _ProductOrderForm.default,
    CustomerOrderForm: _CustomerOrderForm.default
  }
})], OrderModal);
var _default = exports.default = OrderModal;